import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../../lib/api';
import { useAuth } from '../../contexts/AuthContext';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const [form, setForm] = useState({
    name: '', email: '', password: '', password_confirmation: '',
    company_name: '', phone: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      const data = await register(form);
      await refreshUser();
      navigate(data.redirect || '/client');
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        setErrors(err.response.data.errors);
      } else {
        setErrors({ general: [err.response?.data?.message || 'Registration failed.'] });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-white mb-1">Create your account</h2>
      <p className="text-blue-200/60 mb-8">Start managing your web applications</p>

      {errors.general && (
        <div className="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-300 text-sm">
          {errors.general[0]}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="label">Full name</label>
          <input id="name" type="text" value={form.name} onChange={set('name')}
            className={`input-field ${errors.name ? 'input-error' : ''}`}
            placeholder="John Doe" required />
          {errors.name && <p className="error-text">{errors.name[0]}</p>}
        </div>

        <div>
          <label htmlFor="email" className="label">Email address</label>
          <input id="email" type="email" value={form.email} onChange={set('email')}
            className={`input-field ${errors.email ? 'input-error' : ''}`}
            placeholder="you@company.com" required />
          {errors.email && <p className="error-text">{errors.email[0]}</p>}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="company_name" className="label">Company (optional)</label>
            <input id="company_name" type="text" value={form.company_name} onChange={set('company_name')}
              className="input-field" placeholder="Acme Inc." />
          </div>
          <div>
            <label htmlFor="phone" className="label">Phone (optional)</label>
            <input id="phone" type="tel" value={form.phone} onChange={set('phone')}
              className="input-field" placeholder="+1 234 567 890" />
          </div>
        </div>

        <div>
          <label htmlFor="password" className="label">Password</label>
          <input id="password" type="password" value={form.password} onChange={set('password')}
            className={`input-field ${errors.password ? 'input-error' : ''}`}
            placeholder="Min 8 chars, mixed case + number" required />
          {errors.password && <p className="error-text">{errors.password[0]}</p>}
        </div>

        <div>
          <label htmlFor="password_confirmation" className="label">Confirm password</label>
          <input id="password_confirmation" type="password" value={form.password_confirmation}
            onChange={set('password_confirmation')}
            className="input-field" placeholder="Re-enter your password" required />
        </div>

        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? 'Creating account...' : 'Create account'}
        </button>
      </form>

      <p className="mt-6 text-center text-sm text-blue-200/60">
        Already have an account?{' '}
        <Link to="/login" className="link">Sign in</Link>
      </p>
    </div>
  );
}
